import angular from 'angular';

import InventoryTransitionsHistoryIndependentTabComponent from './inventory-transitions-history-independent-tab.component';

export default angular
  .module('inventory-transitions-history-independent-tab', [])
  .component('inventoryTransitionsHistoryIndependentTab', new InventoryTransitionsHistoryIndependentTabComponent());



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/components/inventory-transitions-history-independent-tab/inventory-transitions-history-independent-tab.module.js